import { init } from "@ln/user.client.libs";

class UCL {
  constructor() {
    if (!UCL.instance) {
      // TODO: Pasar al enviroment
      const methods = init({
        keyDatadog: "pub5050341413b972abc6b3999f545122c7",
      });
      Object.assign(this, methods);
      UCL.instance = this;
    } else {
      const methods = UCL.instance;
      Object.assign(this, methods);
    }
  }

  async getUserTokens() {
    if (typeof window === "undefined") return {};

    const { BuildBearerAccessTokenAsync, GetIdTokenValidatedAsync } = this;
    try {
      const userIdToken = await GetIdTokenValidatedAsync();
      const userBearerAccessToken = await BuildBearerAccessTokenAsync();

      return {
        userBearerAccessToken: userBearerAccessToken ?? undefined,
        userIdToken,
      };
    } catch (error) {
      console.error(
        `customEvent ${JSON.stringify({
          eventData: {
            evento: "getUserTokens error",
            error,
          },
        })}`
      );
      return {
        userBearerAccessToken: undefined,
        userIdToken: undefined,
      };
    }
  }
}
export default UCL;
